import {
  FormControl,
  RadioGroup,
  Stack,
  Radio,
  Text,
  FormLabel,
  Input,
  VStack,
  Button,
} from '@chakra-ui/react'
import { useContext, useState } from 'react'
import { RPSContext } from '../../context/RPSContext'
import { isValidETHAddress } from '../../utils/minorUtils'

const GameEntry = () => {
  const [gameType, setGameType] = useState('NewGame')
  const [playerRole, setPlayerRole] = useState('Initiator')
  const { setGameDetails, gameDetails, nextForm } = useContext(RPSContext)
  const [opponent, setOpponent] = useState('')

  function setPlayerNOpponent(address: string) {
    setOpponent(address)
    if (gameType === 'NewGame') {
      setGameDetails({ ...gameDetails, initiator: gameDetails.player, responder: address })
    }
    if (gameType === 'JoinGame' && playerRole === 'Initiator') {
      setGameDetails({ ...gameDetails, initiator: gameDetails.player, responder: address })
    }
    if (gameType === 'JoinGame' && playerRole === 'Responder') {
      setGameDetails({ ...gameDetails, initiator: address, responder: gameDetails.player })
    }
  }

  function takeAction() {
    if (gameDetails.state === -1 || gameDetails.state === 0) {
      nextForm(2)
    }
    if (gameDetails.state === 1) {
      if (
        (gameDetails.player === gameDetails.initiator && gameDetails.initiator_state === 1) ||
        (gameDetails.player === gameDetails.responder && gameDetails.responder_state === 1)
      ) {
        nextForm(3)
      } else if (
        (gameDetails.player === gameDetails.initiator && gameDetails.initiator_state === 2) ||
        (gameDetails.player === gameDetails.responder && gameDetails.responder_state === 2)
      ) {
        nextForm(5)
      }
    }
    if (gameDetails.state === 2 || gameDetails.state === 3) {
      nextForm(4)
    }
  }

  return (
    <VStack spacing={'20px'} minW={{ base: 'md', md: 'lg', lg: 'lg' }}>
      <FormControl>
        <RadioGroup onChange={setGameType} value={gameType}>
          <Stack direction="column">
            <Radio size="lg" colorScheme="teal" value="NewGame">
              <Text fontSize={'xl'}>New Game</Text>
            </Radio>
            <Radio size="lg" colorScheme="teal" value="JoinGame" pt={'md'}>
              <Text fontSize={'xl'}>Join Game</Text>
            </Radio>
          </Stack>
        </RadioGroup>
      </FormControl>
      {gameType === 'JoinGame' && (
        <FormControl pl="25px">
          <FormLabel color={'teal'} fontWeight="bold">
            Join As
          </FormLabel>
          <RadioGroup onChange={setPlayerRole} value={playerRole}>
            <Stack direction="column">
              <Radio size="md" colorScheme="teal" value="Initiator">
                <Text fontSize={'lg'}>Initiator</Text>
              </Radio>
              <Radio size="md" colorScheme="teal" value="Responder" pt={'sm'}>
                <Text fontSize={'lg'}>Responder</Text>
              </Radio>
            </Stack>
          </RadioGroup>
        </FormControl>
      )}
      <FormControl id="opponent">
        <FormLabel>{`${
          gameType === 'NewGame'
            ? 'Responder'
            : playerRole === 'Initiator'
            ? 'Responder'
            : 'Initiator'
        } Address`}</FormLabel>
        <Input
          placeholder="0x1234...5678"
          _placeholder={{ color: 'gray.500' }}
          type="text"
          onChange={(e) => setPlayerNOpponent(e.target.value)}
          value={opponent}
          maxW={'md'}
        />
      </FormControl>
      <Button
        colorScheme="teal"
        variant="outline"
        isDisabled={
          !gameDetails.player ||
          !isValidETHAddress(gameDetails.initiator) ||
          !isValidETHAddress(gameDetails.responder) ||
          !isValidETHAddress(opponent)
        }
        onClick={(e) => {
          e.preventDefault()
          takeAction()
        }}
      >
        {!gameDetails.player
          ? 'Wallet Not Connected'
          : gameType === 'JoinGame'
          ? 'Continue Game'
          : 'Start Game'}
      </Button>
    </VStack>
  )
}
export default GameEntry
